<mat-slide-toggle
    [@.disabled]="true"
    #slider
    [checked]="checked"
    (change)="onCheckedChange(slider)"
    [disabled]="disabled">
</mat-slide-toggle>